import { Component, Input, computed, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddressInfo } from '../../../order-v2.types';
import { LogisticsCardComponent, LogisticsCardField } from '../logistics-card/logistics-card.component';

@Component({
  selector: 'app-pickup-address-card',
  standalone: true,
  imports: [CommonModule, LogisticsCardComponent],
  template: `<app-logistics-card title="Endereço de retirada" [fields]="fields()" />`,
})
export class PickupAddressCardComponent {
  private readonly _address = signal<AddressInfo | null>(null);
  @Input({ required: true }) set address(value: AddressInfo) {
    this._address.set(value);
  }

  readonly fields = computed<LogisticsCardField[]>(() => {
    const a = this._address();
    if (!a) return [];
    const fullAddress = a.fullAddress
      ? `${a.fullAddress}${a.zipCode ? ' — CEP ' + a.zipCode : ''}`
      : null;
    return [
      { label: 'destinatário', value: a.recipientName },
      { label: 'id loja', value: a.pickupPointId ?? null },
      { label: 'nome loja', value: a.pickupStoreName ?? null },
      { label: 'endereço', value: fullAddress },
    ];
  });
}
